import {NavigationMenu} from "./NavigationMenu";
import React, {useState} from "react";
import styled from "styled-components";
import {Inventory} from "./Inventory";
import {PollutionMeter} from "./PollutionMeter";
import {CraftingQueueSidebar} from "../Crafting/CraftingQueueSidebar";

const N = {
    Wrapper: styled.div`
      display: flex;
    `,
    Navigation: styled.nav`
      flex: 1;
      min-height: 100vh;
      margin-right: 280px;
    `,
    SidebarGutter: styled.div`
    width: 24px;`
}

const S = {
    SideBar: styled.nav`
      display: flex;
      flex-direction: column;
      width: 260px;
      background-color: transparent;
    `,
    SideBarHeader: styled.nav`
    `,
}

function Sidebar() {
    const [sidebarIsOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => setSidebarOpen(!sidebarIsOpen);

    return <S.SideBar>
        <S.SideBarHeader>
        </S.SideBarHeader>
        <Inventory/>
    </S.SideBar>

}

export function Layout() {

    return <N.Wrapper>
        <Sidebar />
        <N.SidebarGutter />
        <N.Navigation>
            <NavigationMenu/>
        </N.Navigation>
        <PollutionMeter />
        <CraftingQueueSidebar />
    </N.Wrapper>
}